import React ,{CSSProperties}from 'react'
import { IconButton } from '../icon-button'
import { useTranslation } from 'react-multi-lang'
import {AttachMoney ,FileDownloadDone ,Print ,CheckCircleOutline ,ThumbUp
,Receipt,LocalShipping,Construction ,Launch} from '@mui/icons-material'

interface iProps_old {id:number,fun:Function ,style?:CSSProperties,disabled?:boolean}

export  function OperationStatus_old({id,fun,style,disabled}:iProps) {
   let  t=useTranslation()
   type tOperations = {[kye:number]:any}
    const operations:tOperations = {
        12 :{icon:<IconButton 
            DoIcon={<AttachMoney sx={{color:'var(--primary-color)'}} />}
             value={false}
            doTitle={t("fix_prices")}
            cancelTitle={t("fix_prices")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}

            />,
            status:t("open")
        },
        13: {
            icon:<IconButton 
            DoIcon={<AttachMoney sx={{color:'var(--primary-color)'}} />}
             value={true}
            doTitle={t("cancel_prices")}
            cancelTitle={t("cancel_prices")}
            cancelFunction={()=>fun()}
            doFunction={()=>{return undefined}}
            style={style}
            disabled={disabled}
            />,
            status:t("priced")
           
        },
        14: {
            icon:<IconButton 
            DoIcon={<Construction sx={{color:'var(--primary-color)'}} />}
             value={false}
            doTitle={t("create_job_order")}
            cancelTitle={t("create_job_order")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("priced")
            
        },
         15: {
            icon:<IconButton 
            DoIcon={<Construction sx={{color:'var(--primary-color)'}} />}
             value={true}
            doTitle={t("cancel_job_order")}
            cancelTitle={t("cancel_job_order")}
            cancelFunction={()=>fun()}
            doFunction={()=>{return undefined}}
            style={style}
            disabled={disabled}
            />,
            status:t("in_production")
         },
         16: {
            icon:<IconButton 
            DoIcon={<Print sx={{color:'var(--primary-color)'}} />}
             value={true}
            doTitle={t("print_job_order")}
            cancelTitle={t("print_job_order")}
            cancelFunction={()=>{}}
            doFunction={()=>{return undefined}}
            style={style}
            disabled={disabled}
            />,
            status:t("in_production")
         },
         17: {
            icon:<IconButton 
            DoIcon={<FileDownloadDone sx={{color:'var(--primary-color)'}} />}
             value={false}
            doTitle={t("finish_production")}
            cancelTitle={t("finish_production")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("in_production")
         },
         18: {
            icon:<IconButton 
            DoIcon={<FileDownloadDone sx={{color:'var(--primary-color)'}} />}
             value={true}
            doTitle={t("cancel_ready")}
            cancelTitle={t("cancel_ready")}
            cancelFunction={()=>fun()}
            doFunction={()=>{return undefined}}
            style={style}
            disabled={disabled}
            />,
            status:t("ready")
         },
         19: {
            icon:<IconButton 
            DoIcon={<Receipt sx={{color:'var(--primary-color)'}} />}
             value={false}
            doTitle={t("issue_invoice")}
            cancelTitle={t("issue_invoice")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("ready")
         },
         20: {
            icon:<IconButton 
            DoIcon={<Receipt sx={{color:'var(--primary-color)'}} />}
             value={true}
            doTitle={t("cancel_invoice")}
            cancelTitle={t("cancel_invoice")}
            cancelFunction={()=>fun()}
            doFunction={()=>{return undefined}}
            style={style}
            disabled={disabled}
            />,
            status:t("invoice_issued")
         },
         21:{
            icon:<IconButton 
            DoIcon={<LocalShipping sx={{color:'var(--primary-color)'}} />}
             value={false}
            doTitle={t("issue_delivery_order")}
            cancelTitle={t("issue_delivery_order")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("invoice_issued")
         },
         22:{
            icon:<IconButton 
            DoIcon={<LocalShipping sx={{color:'var(--primary-color)'}} />}
             value={true}
            doTitle={t("cancel_delivery_order")}
            cancelTitle={t("cancel_delivery_order")}
            cancelFunction={()=>fun()}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("cancel_delivery_order")
         },
         23: {
           
            icon:<IconButton 
            DoIcon={<CheckCircleOutline sx={{color:'var(--primary-color)'}} />}
             value={false}
            doTitle={t("close_order")}
            cancelTitle={t("close_order")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("close_order")
         },
         24: {
              
            icon:<IconButton 
            DoIcon={<Launch sx={{color:'var(--primary-color)'}} />}
             value={false}
            doTitle={t("show_inoice")}
            cancelTitle={t("show_invoice")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("show_invoice")
         }

    }
  
  return (

             id && id !== -1?
                operations[id]['icon']:null
            
  
  )
}






interface iProps {id:number,fun:Function ,style?:CSSProperties,disabled?:boolean,next?:boolean}

export default function OperationStatus({id,fun,style,disabled,next}:iProps) {
   let  t=useTranslation()
   type tOperations = {[kye:number]:any}
    const operations:tOperations = {
        1:[{icon:<IconButton 
            DoIcon={<AttachMoney sx={{color:'var(--primary-color)'}} />}
             value={false}
            doTitle={t("fix_prices")}
            cancelTitle={t("fix_prices")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}

            />,
            status:t("open")
        }],
        2:[ {
            icon:<IconButton 
            DoIcon={<AttachMoney sx={{color:'var(--primary-color)'}} />}
             value={true}
            doTitle={t("cancel_prices")}
            cancelTitle={t("cancel_prices")}
            cancelFunction={()=>fun()}
            doFunction={()=>{return undefined}}
            style={style}
            disabled={disabled}
            />,
            status:t("priced")
           
        },
         {
            icon:<IconButton 
            DoIcon={<Receipt sx={{color:'var(--primary-color)'}} />
            //<Construction sx={{color:'var(--primary-color)'}}  />
            }
             value={false}
            doTitle={t("issue_invoice")}
            cancelTitle={t("issue_invoice")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("priced")
            
        }],
         4: [{
            icon:<IconButton 
            DoIcon={<Construction sx={{color:'var(--primary-color)'}} />}
             value={true}
            doTitle={t("cancel_job_order")}
            cancelTitle={t("cancel_job_order")}
            cancelFunction={()=>fun()}
            doFunction={()=>{return undefined}}
            style={style}
            disabled={disabled}
            />,
            status:t("in_production")
         },
          {
            icon:<IconButton 
            DoIcon={<Print sx={{color:'var(--primary-color)'}} />}
             value={true}
            doTitle={t("print_job_order")}
            cancelTitle={t("print_job_order")}
            cancelFunction={()=>{}}
            doFunction={()=>{return undefined}}
            style={style}
            disabled={disabled}
            />,
            status:t("in_production")
         },
          {
            icon:<IconButton 
            DoIcon={<FileDownloadDone sx={{color:'var(--primary-color)'}} />}
             value={false}
            doTitle={t("finish_production")}
            cancelTitle={t("finish_production")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("in_production")
         }],
         5: [{
            icon:<IconButton 
            DoIcon={<FileDownloadDone sx={{color:'var(--primary-color)'}} />}
             value={true}
            doTitle={t("cancel_ready")}
            cancelTitle={t("cancel_ready")}
            cancelFunction={()=>fun()}
            doFunction={()=>{return undefined}}
            style={style}
            disabled={disabled}
            />,
            status:t("ready")
         },

         {
            icon:<IconButton 
            DoIcon={<LocalShipping sx={{color:'var(--primary-color)'}} />}
             value={false}
            doTitle={t("issue_delivery_order")}
            cancelTitle={t("issue_delivery_order")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("ready")
         }
         ],
         3:[ {
            icon:<IconButton 
            DoIcon={<Receipt sx={{color:'var(--primary-color)'}} />}
             value={true}
            doTitle={t("cancel_invoice")}
            cancelTitle={t("cancel_invoice")}
            cancelFunction={()=>fun()}
            doFunction={()=>{return undefined}}
            style={style}
            disabled={disabled}
            />,
            status:t("invoice_issued")
         },
         {
              
            icon:<IconButton 
            DoIcon={<Launch sx={{color:'var(--primary-color)'}} />}
             value={false}
            doTitle={t("show_inoice")}
            cancelTitle={t("show_invoice")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("show_invoice")
         }
,
{
            icon:<IconButton 
            DoIcon={<Construction sx={{color:'var(--primary-color)'}}  />}
             value={false}
            doTitle={t("create_job_order")}
            cancelTitle={t("create_job_order")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("invoice_issued")
         }
      
         // {
         //    icon:<IconButton 
         //    DoIcon={<LocalShipping sx={{color:'var(--primary-color)'}} />}
         //     value={false}
         //    doTitle={t("issue_delivery_order")}
         //    cancelTitle={t("issue_delivery_order")}
         //    cancelFunction={()=>{}}
         //    doFunction={()=>fun()}
         //    style={style}
         //    disabled={disabled}
         //    />,
         //    status:t("invoice_issued")
         // }
      ],
         6:[{
            icon:<IconButton 
            DoIcon={<LocalShipping sx={{color:'var(--primary-color)'}} />}
             value={true}
            doTitle={t("cancel_delivery_order")}
            cancelTitle={t("cancel_delivery_order")}
            cancelFunction={()=>fun()}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("cancel_delivery_order")
         },
         {
           
            icon:<IconButton 
            DoIcon={<CheckCircleOutline sx={{color:'var(--primary-color)'}} />}
             value={false}
            doTitle={t("close_order")}
            cancelTitle={t("close_order")}
            cancelFunction={()=>{}}
            doFunction={()=>fun()}
            style={style}
            disabled={disabled}
            />,
            status:t("close_order")
         }],
         
    }
  const op = id && id !== -1? operations[id]: null

  return (

             op?
               next?
             op[op.length-1]['icon']
                :
               op[0]['icon']
                :null
            
  
  )
}
